import { create } from 'zustand';

interface AuthDialogStore {
    open: boolean;
    onAuthenticated: (action?: () => void) => void;
    modeType: "sign-in" | "sign-up";
    signInFeatureSlug?: string;
    signInTitle?: string;
    signInDescription?: string;
    setShowDialog: (show: boolean) => void;
    showAuthDialog: (props: {
        open: boolean;
        onAuthenticated: (action?: () => void) => void;
        modeType: "sign-in" | "sign-up";
        signInFeatureSlug?: string;
        signInTitle?: string;
        signInDescription?: string;
    }) => void;
}

export const useAuthDialogStore = create<AuthDialogStore>((set) => ({
    open: false,
    onAuthenticated: () => {},
    modeType: "sign-in",
    signInFeatureSlug: undefined,
    signInTitle: undefined,
    signInDescription: undefined,
    setShowDialog: (show) => set({ open: show }),
    showAuthDialog: ({ open, onAuthenticated, modeType, signInFeatureSlug, signInTitle, signInDescription }) => {
        set({
            open,
            onAuthenticated,
            modeType,
            signInFeatureSlug,
            signInTitle,
            signInDescription,
        });
    },
}));
